const HELP_TEXTS = {
  header: {
    owner:
      'This is a read-only field. It can only be changed in the Opportunity screen.',
  },
  statusChanges: {
    approve:
      'The linked account needs a SAP Business Partner ID before the invoice can be approved',
    export: 'There are currently no approved invoices that could be exported',
    submitForReview:
      'Please add some booking entries to the invoice first to submit it for review',
    selectInvoice: 'Select approved invoices to push it to SAP',
  },
  actionButtons: {
    generateCoInvestEntries:
      'Create lines based on the campain lines Co-Invest amounts',
    generateMediaEntries:
      'Generate lines based on the Campaign actual spends (equivalent to MSTR ZMS Net Client Revenues) and actual Runtime. It takes ~50 seconds for the lines to be generated',
    generateNonMediaEntries:
      'Create lines for non-media products (Creative, Insight, Others) based on the campain lines (Net Client Budget)',
  },
};

export default HELP_TEXTS;
